export default __webpack_public_path__ + "static/media/Aircraft9-t.79402c68.png";